import filter from 'ramda/es/filter';

import {
  SHOP_CART_REQUEST,
  SHOP_CART_SUCCESS,
  SHOP_CART_FAILURE,
} from 'app/common/actions/shop/cart';

import {
  SHOP_ADD2CART_REQUEST,
  SHOP_ADD2CART_SUCCESS,
  SHOP_ADD2CART_FAILURE,
} from 'app/common/actions/shop/cart/add2cart';

import {
  SHOP_UPDATECART_REQUEST,
  SHOP_UPDATECART_SUCCESS,
  SHOP_UPDATECART_FAILURE,
} from 'app/common/actions/shop/cart/updateCartItem';

import {
  SHOP_DELETECART_REQUEST,
  SHOP_DELETECART_SUCCESS,
  SHOP_DELETECART_FAILURE,
} from 'app/common/actions/shop/cart/deleteCartItem';


const defaultState = {
  amountDiscount: '',
  cartItems: [],
  discountCode: null,
  id: '',
  total: '0.0',
  utmCampaign: null,
  loading: true,
  adding: false,
  updating: false,
  deleting: false,
};

const categories = (state = defaultState, { type, payload }) => {
  switch (type) {
    case SHOP_CART_REQUEST: {
      return { ...state, loading: true };
    }

    case SHOP_CART_SUCCESS: {
      return { ...state, loading: false, ...payload };
    }

    case SHOP_CART_FAILURE: {
      return { ...defaultState, loading: false };
    }

    // Добавление в корзину

    case SHOP_ADD2CART_REQUEST: {
      return { ...state, adding: true };
    }

    case SHOP_ADD2CART_SUCCESS: {
      return { ...state, adding: false, ...payload };
    }

    case SHOP_ADD2CART_FAILURE: {
      return { ...state, adding: false };
    }

    // Обновление количества, возможно потом других параметров

    case SHOP_UPDATECART_REQUEST: {
      return { ...state, updating: true };
    }

    case SHOP_UPDATECART_SUCCESS: {
      return { ...state, updating: false, ...payload };
    }

    case SHOP_UPDATECART_FAILURE: {
      return { ...state, updating: false };
    }

    // Удаление записи в корзине

    case SHOP_DELETECART_REQUEST: {
      return { ...state, deleting: true };
    }

    case SHOP_DELETECART_SUCCESS: {
      return {
        ...state,
        deleting: false,
        cartItems: filter(({ id }) => (id !== payload.itemId), state.cartItems),
      };
    }

    case SHOP_DELETECART_FAILURE: {
      return { ...state, deleting: false };
    }

    default:
  }
  return state;
};

export default categories;
